export default "__VITE_ASSET__BzRQWGsL__"